import script from "./invoicing.vue?vue&type=script&setup=true&lang=js"
export * from "./invoicing.vue?vue&type=script&setup=true&lang=js"

import "./invoicing.vue?vue&type=style&index=0&id=3a887625&lang=scss&scoped=true"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a887625"]])

export default __exports__